import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faPenToSquare, faXmark, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Navigation from '../../../Layouts/Navigation/Navigation';
import { BASE_URL } from '../../../utils/constants';


function ControlInquilinos() {
  const { id_torre } = useParams();
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [apartments, setApartments] = useState([]);
  const [selectedApartment, setSelectedApartment] = useState("");

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [usuario, setUsuario] = useState("");
  const [identificacion, setIdentificacion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // Estado para mostrar/ocultar contraseña
  
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // Agrega un nuevo estado para el usuario seleccionado y el modal de edición
  const [selectedUser, setSelectedUser] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  //Snack notifications
  const [openSnack, setOpenSnack] = React.useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  
  const handleClickSnack = () => {
    setOpenSnack(true);
  };

  const handleCloseSnack = () => {
    setOpenSnack(false);
  };
  
  const handleClose = () => {
    setOpen(false);
    setNombre("");
    setApellido("");
    setEmail("");
    setUsuario("");
    setIdentificacion("");
    setTelefono("");
    setPassword("");
    setSelectedApartment("");
  };

  const getInquilinos = () => {
    axios.get(`${BASE_URL}/inquilinos/${id_torre}`)
      .then(response => {
        setUsers(response.data);
        setFilteredUsers(response.data);
      })
      .catch(error => console.log(error));
  };
  
  useEffect(() => {
    getInquilinos();
  }, [id_torre]);

  // Auto-dismiss snack notifications after 4s
  useEffect(() => {
    if (openSnack) {
      const t = setTimeout(() => setOpenSnack(false), 4000);
      return () => clearTimeout(t);
    }
  }, [openSnack]);
    
  const handleClickGetAptos = () => {
    setOpen(true);
    axios.get(`${BASE_URL}/apartamentos/torre/${id_torre}`)
      .then(response => {
        setApartments(response.data);
        console.log(response.data);
      })
      .catch(error => console.log(error));
  };

  const handleAddSubmit = (event) => {
    event.preventDefault();
  
    const userData = {
      nombre: nombre,
      apellido: apellido,
      email: email,
      usuario: usuario,
      identificacion: identificacion,
      telefono: telefono,
      id_apto: selectedApartment,
      password: password
    };
    console.log(userData);
  
    axios.post(`${BASE_URL}/addInquilino`, userData)
      .then(response => {
        console.log(response.status);
        if (response.status === 200) {
          setSnackStatus("success");
          setSnackMessage("Inquilino guardado con éxito!");
          getInquilinos();
          handleClose();
        }
        handleClickSnack();
      })
      .catch(error => {
        console.log(error);
        setSnackStatus("error");
        setSnackMessage(error.response?.data?.message || "Error al guardar el inquilino.");
        handleClickSnack();
      });
  };

  // Esta función se llama cuando se hace clic en el botón de edición de un usuario
  const handleEditUser = (user) => {
    console.log("Usuario seleccionado:", user);
    axios.get(`${BASE_URL}/apartamentos/torre/${id_torre}`)
      .then(response => {
        console.log("Apartamentos obtenidos:", response.data);
        setApartments(response.data);
        setSelectedApartment(user.id_apto);
      })
      .catch(error => console.error("Error al obtener apartamentos:", error));
    setSelectedUser({ ...user, password: "", passwordConfirm: "" });
    setEditOpen(true);
  };

  // Esta función se llama cuando se envía el formulario de edición
  const handleEditSubmit = (event) => {
    event.preventDefault();
    
    const userEditData = {
      nombre: selectedUser.nombre,
      apellido: selectedUser.apellido,
      email: selectedUser.email,
      usuario: selectedUser.usuario,
      identificacion: selectedUser.identificacion,
      telefono: selectedUser.telefono,
      password: selectedUser.password,
      id_apto: selectedApartment,
      id_estado: selectedUser.id_estado
    };
    console.log(userEditData);

    // If a new password was provided, require confirmation and ensure they match
    if (selectedUser.password && selectedUser.password.length > 0) {
      if (!selectedUser.passwordConfirm || selectedUser.password !== selectedUser.passwordConfirm) {
        setSnackStatus("error");
        setSnackMessage("Las contraseñas no coinciden.");
        handleClickSnack();
        return;
      }
    }

    axios.put(`${BASE_URL}/updateInquilino/${selectedUser.id_usuario}`, {
      ...userEditData,
      id_usuario: selectedUser.id_usuario
    })
    .then(response => {
      console.log(response);
      if (response.status === 200) {
        setSnackStatus("success");
        setSnackMessage("Usuario editado con éxito!");
        getInquilinos();
        setEditOpen(false);
      } else {
        setSnackStatus("error");
        setSnackMessage("Error al editar el usuario.");
      }
      handleClickSnack();
    })
    .catch(error => {
      console.log(error);
      setSnackStatus("error");
      setSnackMessage(error.response?.data?.message || "Error al editar el usuario.");
      handleClickSnack();
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const filtered = users.filter((user) =>
      user.nombre.toLowerCase().includes(value) ||
      user.apellido.toLowerCase().includes(value) ||
      user.email.toLowerCase().includes(value) ||
      user.usuario.toLowerCase().includes(value) ||
      user.identificacion.toLowerCase().includes(value) ||
      user.telefono.toLowerCase().includes(value) ||
      user.num_apartamento.toString().toLowerCase().includes(value)
    );
    setFilteredUsers(filtered);
    setPage(0);
  };

  return (
    <>
      <Navigation/>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
        <div className="max-w-7xl mx-auto">
          {/* Snackbar Alert */}
          {openSnack && (
            <div className={`fixed top-4 right-4 z-[9999] p-4 rounded-lg shadow-lg ${
              snackStatus === 'success' ? 'bg-green-500' : 'bg-red-500'
            } text-white animate-fade-in-down`}>
              <div className="flex items-center gap-2">
                <span>{snackMessage}</span>
                <button onClick={handleCloseSnack} className="ml-2">
                  <FontAwesomeIcon icon={faXmark} className="h-5 w-5" />
                </button>
              </div>
            </div>
          )}

          {/* Header */}
          <div className="mb-8">
            <h1 className="text-4xl font-bold text-gray-800 text-center mb-6">
              Inquilinos de la Torre {id_torre}
            </h1>
            
            {/* Search and Add Button */}
            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between mb-6">
              <div className="flex-1 w-full sm:max-w-md">
                <input
                  type="text"
                  placeholder="Buscar por nombre, apellido, email, usuario, identificación, teléfono o apartamento..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="input-field w-full"
                />
              </div>
              <button
                onClick={handleClickGetAptos}
                className="btn-primary flex items-center gap-2 whitespace-nowrap"
              >
                <FontAwesomeIcon icon={faUserPlus} className="h-5 w-5" />
                Agregar Inquilino
              </button>
            </div>
          </div>

          {/* Modal para agregar inquilino */}
          {open && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
                  <h2 className="text-2xl font-bold text-gray-800">Registro de Nuevo Usuario</h2>
                  <p className="text-gray-600 mt-1">Ingrese los datos del nuevo inquilino</p>
                </div>
                <form onSubmit={handleAddSubmit}>
                  <div className="p-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Nombre *
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={nombre}
                          onChange={(event) => setNombre(event.target.value)}
                          required
                          autoFocus
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Apellido *
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={apellido}
                          onChange={(event) => setApellido(event.target.value)}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Email *
                        </label>
                        <input
                          type="email"
                          className="input-field"
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Usuario *
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={usuario}
                          onChange={(event) => setUsuario(event.target.value)}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Identificación *
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={identificacion}
                          onChange={(event) => setIdentificacion(event.target.value)}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Teléfono *
                        </label>
                        <input
                          type="number"
                          className="input-field"
                          value={telefono}
                          onChange={(event) => setTelefono(event.target.value)}
                          required
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Apartamento *
                        </label>
                        <select
                          className="input-field"
                          value={selectedApartment}
                          onChange={(event) => setSelectedApartment(event.target.value)}
                          required
                        >
                          <option value="">Seleccione un apartamento</option>
                          {apartments.map((apartment) => (
                            <option key={apartment.id_apartamento} value={apartment.id_apartamento}>
                              {apartment.num_apartamento}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Contraseña *
                        </label>
                        <input
                          type="password"
                          className="input-field"
                          value={password}
                          onChange={(event) => setPassword(event.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="sticky bottom-0 bg-gray-50 px-6 py-4 rounded-b-2xl flex justify-end gap-3 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={handleClose}
                      className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn-primary"
                    >
                      Registrar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Modal para editar inquilino */}
          {editOpen && selectedUser && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 rounded-t-2xl">
                  <h2 className="text-2xl font-bold text-gray-800">Editar Usuario</h2>
                  <p className="text-gray-600 mt-1">Modifique los datos del inquilino</p>
                </div>
                <form onSubmit={handleEditSubmit}>
                  <div className="p-6 space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Nombre
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={selectedUser.nombre}
                          onChange={(event) => setSelectedUser({...selectedUser, nombre: event.target.value})}
                          autoFocus
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Apellido
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={selectedUser.apellido}
                          onChange={(event) => setSelectedUser({...selectedUser, apellido: event.target.value})}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Email
                        </label>
                        <input
                          type="email"
                          className="input-field"
                          value={selectedUser.email}
                          onChange={(event) => setSelectedUser({...selectedUser, email: event.target.value})}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Usuario
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={selectedUser.usuario}
                          onChange={(event) => setSelectedUser({...selectedUser, usuario: event.target.value})}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Identificación
                        </label>
                        <input
                          type="text"
                          className="input-field"
                          value={selectedUser.identificacion}
                          onChange={(event) => setSelectedUser({...selectedUser, identificacion: event.target.value})}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Teléfono
                        </label>
                        <input
                          type="number"
                          className="input-field"
                          value={selectedUser.telefono}
                          onChange={(event) => setSelectedUser({...selectedUser, telefono: event.target.value})}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Contraseña
                        </label>
                        <div className="relative">
                          <input
                            type={showPassword ? 'text' : 'password'}
                            className="input-field pr-10"
                            value={selectedUser.password || ''}
                            onChange={(e) => setSelectedUser({ ...selectedUser, password: e.target.value })}
                          />
                          <button
                            type="button"
                            onClick={handleClickShowPassword}
                            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                          >
                            {showPassword ? <FontAwesomeIcon icon={faEyeSlash} className="h-5 w-5" /> : <FontAwesomeIcon icon={faEye} className="h-5 w-5" />}
                          </button>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Confirmar Contraseña
                        </label>
                        <input
                          type={showPassword ? 'text' : 'password'}
                          className="input-field"
                          value={selectedUser.passwordConfirm || ''}
                          onChange={(e) => setSelectedUser({ ...selectedUser, passwordConfirm: e.target.value })}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Apartamento
                        </label>
                        <select
                          className="input-field"
                          value={selectedApartment}
                          onChange={(event) => setSelectedApartment(event.target.value)}
                        >
                          <option value="">Seleccione un apartamento</option>
                          {apartments.map((apartment) => (
                            <option key={apartment.id_apartamento} value={apartment.id_apartamento}>
                              {apartment.num_apartamento}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Estado
                        </label>
                        <select
                          className="input-field"
                          value={selectedUser.id_estado}
                          onChange={(event) => setSelectedUser({...selectedUser, id_estado: parseInt(event.target.value)})}
                        >
                          <option value={1}>Activo</option>
                          <option value={0}>Inactivo</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="sticky bottom-0 bg-gray-50 px-6 py-4 rounded-b-2xl flex justify-end gap-3 border-t border-gray-200">
                    <button
                      type="button"
                      onClick={() => setEditOpen(false)}
                      className="px-6 py-2.5 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors font-medium"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="btn-primary"
                    >
                      Guardar Cambios
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* Table */}
          <div className="bg-white rounded-2xl shadow-md overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gradient-to-r from-primary-500 to-primary-700">
                  <tr>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Nombre</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Apellido</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Email</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Usuario</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Identificación</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Teléfono</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Apartamento</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Estado</th>
                    <th className="px-6 py-4 text-center text-sm font-bold text-white uppercase tracking-wider">Acciones</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((user) => (
                      <tr key={user.id_usuario} className="hover:bg-gray-50 transition-colors">
                        <td className="px-6 py-4 text-center text-sm text-gray-900">{user.nombre}</td>
                        <td className="px-6 py-4 text-center text-sm text-gray-900">{user.apellido}</td>
                        <td className="px-6 py-4 text-center text-sm text-gray-700">{user.email}</td>
                        <td className="px-6 py-4 text-center text-sm text-gray-700">{user.usuario}</td>
                        <td className="px-6 py-4 text-center text-sm text-gray-700">{user.identificacion}</td>
                        <td className="px-6 py-4 text-center text-sm text-gray-700">{user.telefono}</td>
                        <td className="px-6 py-4 text-center text-sm font-medium text-gray-900">{user.num_apartamento}</td>
                        <td className="px-6 py-4 text-center">
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${
                            user.id_estado === 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                          }`}>
                            {user.id_estado === 1 ? 'Activo' : 'Inactivo'}
                          </span>
                        </td>
                        <td className="px-6 py-4 text-center">
                          <button
                            onClick={() => handleEditUser(user)}
                            className="inline-flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors shadow-sm hover:shadow-md"
                            title="Editar usuario"
                          >
                            <FontAwesomeIcon icon={faPenToSquare} className="h-5 w-5" />
                            Editar
                          </button>
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
            
            {/* Pagination */}
            <div className="bg-gray-50 px-6 py-4 flex items-center justify-between border-t border-gray-200">
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-700">Filas por página:</span>
                <select
                  value={rowsPerPage}
                  onChange={handleChangeRowsPerPage}
                  className="input-field py-1 px-2 text-sm"
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <div className="flex items-center gap-4">
                <span className="text-sm text-gray-700">
                  {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, filteredUsers.length)} de {filteredUsers.length}
                </span>
                <div className="flex gap-2">
                  <button
                    onClick={(e) => handleChangePage(e, page - 1)}
                    disabled={page === 0}
                    className="px-3 py-1 bg-white border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
                  >
                    Anterior
                  </button>
                  <button
                    onClick={(e) => handleChangePage(e, page + 1)}
                    disabled={page >= Math.ceil(filteredUsers.length / rowsPerPage) - 1}
                    className="px-3 py-1 bg-white border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ControlInquilinos;
